import { render } from "./ObjectList.vue?vue&type=template&id=7ad1b438"
import script from "./ObjectList.vue?vue&type=script&lang=js"
export * from "./ObjectList.vue?vue&type=script&lang=js"

import "./ObjectList.vue?vue&type=style&index=0&id=7ad1b438&lang=css"
script.render = render

export default script